import { useState } from 'react';
import RoleService from '../../../../services/role_service';
import { initialConfirm } from '../../../../utils';

const DeleteRole = (props) => {
    const [confirm, setConfirm] = useState(initialConfirm);
    
    const askDelete = async () => {
        const lostAccess = await props.losesAccess?.();
        if (lostAccess) return;
        setConfirm({ open: true, message: `Desea eliminar el rol "${props.selectedRole.Name}"`, loading: false, error: '' });
    };

    const closeDeleteModal = async () => {
        const lostAccess = await props.losesAccess?.();
        if (lostAccess) return;
        setConfirm(initialConfirm);
    };

    const handleConfirmDelete = async () => {
        const lostAccess = await props.losesAccess?.();
        if (lostAccess) return;
        props.setLoading(true);
        try {
            const deleted = await RoleService.delete(props.selectedRole.Id)
            if (props.logout(deleted)) return;
            props.setRoles(prev =>
                prev.filter(r => r.Id !== props.selectedRole.Id)
            );
            props.setRole('')
            props.message('Rol eliminado con éxito', 'success');
        } catch (e) {
            props.message(e?.message || e, 'error');
        } finally {
            props.setLoading(false);
            closeDeleteModal()
        }
    };

    return {
        confirm,
        askDelete,
        closeDeleteModal,
        handleConfirmDelete
    }
};

export default DeleteRole;
